import React from "react";
import { Table, Typography } from "antd";

const { Paragraph } = Typography;

const Medication = ({ details }) => {
  const medications = details?.data?.medications;

  const columns = [
    { title: "Medication", dataIndex: "name", key: "name" },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      render: (value) => value?.replaceAll("_", " "),
    },
    { title: "Route", dataIndex: "route", key: "route" },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (value) =>
        value ? (
          <Paragraph
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: "more",
            }}
            style={{
              width: "100%",
              maxWidth: "100%",
              marginBottom: 0,
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {value}
          </Paragraph>
        ) : (
          "-"
        ),
    },
  ];
  return (
    <Table dataSource={medications} pagination={false} columns={columns} />
  );
};

export default Medication;
